<p>studiewijzerlinkjes-new works!</p>
<app-controls-new></app-controls-new>
<app-studiewijzer-donut-new></app-studiewijzer-donut-new>
<app-studiewijzerlinkjes-table></app-studiewijzerlinkjes-table>
<app-studiewijzerlinkjes-detail-new></app-studiewijzerlinkjes-detail-new>
<app-studiewijzerlinkjes-vaksectie-platform-details></app-studiewijzerlinkjes-vaksectie-platform-details>
